import { useEffect, useMemo, useState } from 'react';
import { ConsentDto, PersonInHouseholdDto } from '../graphql/person/generates';
import { hasApprovedConsent } from '../utils/util';
import { UseQueryResult } from '@tanstack/react-query';
import type { ErrorRequestEntity } from '@dvag/dfs-api-client';
import { dashboardUtil } from '../service/model/dashboardUtil';

interface DataInterface {
  personId: string;
  status: string;
}

interface Props {
  householdDashboard: UseQueryResult<
    { consentList: ConsentDto[]; personList: PersonInHouseholdDto[] },
    ErrorRequestEntity
  >;
  section: string | undefined;
}

const { PRIVACY_POLICY } = dashboardUtil;

export const useBottomCard = ({ householdDashboard, section }: Props) => {
  const [consentModalVisibility, setConsentModalVisibility] = useState(false);
  const [isConsentEmailSent, setIsConsentEmailSent] = useState('');
  const [chosenPerson, setChosenPerson] = useState<PersonInHouseholdDto | undefined>();
  const [personListWithConsent, setPersonListWithConsent] = useState<DataInterface[]>([]);
  const personList = useMemo(
    () => householdDashboard?.data?.personList || [],
    [householdDashboard?.data?.personList],
  );

  const isConsentFetching = householdDashboard.isLoading || householdDashboard.isRefetching;

  const showConsentModal = () => setConsentModalVisibility(true);
  const hideConsentModal = () => setConsentModalVisibility(false);
  const setConsentEmailSentStatus = (str: string) => setIsConsentEmailSent(str);

  useEffect(() => {
    if (householdDashboard?.data?.consentList) {
      const listOfConsentGiven = householdDashboard?.data?.consentList?.filter(({ status }) =>
        hasApprovedConsent(status),
      );
      setPersonListWithConsent(listOfConsentGiven);
    }
  }, [householdDashboard?.data?.consentList]);

  useEffect(() => {
    if (section !== PRIVACY_POLICY) {
      hideConsentModal();
    }
  }, [section]);

  return {
    chosenPerson,
    consentModalVisibility,
    hideConsentModal,
    isConsentEmailSent,
    isConsentFetching,
    personList,
    personListWithConsent,
    setChosenPerson,
    setConsentEmailSentStatus,
    showConsentModal,
  };
};
